// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from '../TEMPLATE'

export const Vgen = createSinglePathSVG({
  path: 'M21.551 5.391a6.428 6.428 0 1 0-9.554 8.603l1.434 1.592q.185.206.389.381c-.616.356-1.08.483-1.392.483-.434 0-1.177-.239-2.221-.939-.995-.667-2.03-1.596-2.996-2.584a39 39 0 0 1-3.275-3.849l-.044-.06-.01-.014a2.144 2.144 0 0 0-3.478 2.504l.023.032a23 23 0 0 0 .273.366 43 43 0 0 0 3.445 4.015c1.07 1.097 2.338 2.253 3.674 3.149 1.286.863 2.9 1.666 4.609 1.666 1.732 0 3.304-.82 4.534-1.707 1.269-.915 2.435-2.09 3.4-3.195a37 37 0 0 0 3.296-4.42l.022-.034c.207-.335.31-.706.319-1.074.041-1.38-.829-3.158-2.161-4.597l-.287-.318Zm-3.185 2.868a2.143 2.143 0 0 0-3.184 2.867l1.935 1.91.018-.022a33 33 0 0 0 2.008-2.561c.307-.692.03-1.298-.49-1.876l-.287-.318Z',
  viewBox: '0 0 24 24',
  glyph: 'Vgen',
})
